/**
 * @generated SignedSource<<5a319bc9a84ffeab13631ca5798d158c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuickViewCategory_item$data = {
  readonly quickViewDisplay: {
    readonly paragraphAttributeNames: {
      readonly " $fragmentSpreads": FragmentRefs<"useQuickViewCategory_quickViewCategorySegments">;
    } | null;
  } | null;
  readonly " $fragmentType": "QuickViewCategory_item";
};
export type QuickViewCategory_item$key = {
  readonly " $data"?: QuickViewCategory_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuickViewCategory_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuickViewCategory_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewDisplayType",
      "kind": "LinkedField",
      "name": "quickViewDisplay",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QuickViewCategorySegments",
          "kind": "LinkedField",
          "name": "paragraphAttributeNames",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "useQuickViewCategory_quickViewCategorySegments"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "5583dd08830c064d44275a9899dc6901";

export default node;
